import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import {
  OauthAEMConfig,
  SubmitEmailPayload,
  SubmitEmailResponse
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SubmitEmailService {
  submitEmailHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.submitEmailTarget+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  submitEmail = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    email: string
  ): Observable<SubmitEmailResponse> => {
    const getSubmitEmailUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitEmailUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getSubmitEmailUrl
      }
    ];

    const payload: SubmitEmailPayload = {
      email: email
    };

    return new ApiBuilder<SubmitEmailPayload, SubmitEmailResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitEmailUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.submitEmailHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_EMAIL_SERVICE')
      .withCredentials(true)
      .create();
  };
}
